import useCurrentEnvironment from "./use-environment";

export type CurrentProjectAndEnvNames = {
  isLoading: boolean;
  projName: string;
  envName: string;
};

export default function useCurrentProjectAndEnvNames(): CurrentProjectAndEnvNames {
  const currentEnvironment = useCurrentEnvironment();

  if (!currentEnvironment.loaded || !currentEnvironment.project) {
    return {
      isLoading: true,
      projName: "",
      envName: "",
    };
  }

  return {
    isLoading: false,
    projName: currentEnvironment.project.name,
    envName: currentEnvironment.name,
  };
}
